import React, { createContext, useState, useRef, useContext } from 'react';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false); // This will control the spinner visibility
  const activeRequestCount = useRef(0); // This will track active requests

  const startLoading = () => {
    activeRequestCount.current += 1; // Increment the active request count

    // If this is the first active request, show the loading spinner
    if (activeRequestCount.current === 1) {
      setIsLoading(true); // Trigger re-render to show the spinner
    }
  };

  const stopLoading = () => {
    activeRequestCount.current = Math.max(activeRequestCount.current - 1, 0); // Decrement the active request count

    // If no more active requests, hide the loading spinner
    if (activeRequestCount.current === 0) {
      setIsLoading(false); // Trigger re-render to hide the spinner
    }
  };

  return (
    <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
